import { render, staticRenderFns } from "./SettingNotification.vue?vue&type=template&id=9525a7e2&scoped=true"
import script from "./SettingNotification.vue?vue&type=script&lang=js"
export * from "./SettingNotification.vue?vue&type=script&lang=js"
import style0 from "./SettingNotification.vue?vue&type=style&index=0&id=9525a7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9525a7e2",
  null
  
)

export default component.exports